import {
  AsyncPipe,
  DatePipe,
  LowerCasePipe,
  NgClass,
  NgStyle,
} from '@angular/common';
import { Component, HostListener, inject, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityInformations } from 'app/modules/dashboard/models/activity.model';
import { ModalService } from 'app/services/modal.service';
import { Observable, Subscription } from 'rxjs';

import { TrainingLogSessionModalComponent } from '../../modals/ts-sessions-modal/tl-sessions-modal.component';
import { Store } from '@ngrx/store';
import { Settings } from 'app/modules/dashboard/models/settings.model';
import { selectSettings } from 'app/store/me/me.selectors';

@Component({
  imports: [
    NgClass,
    NgStyle,
    LowerCasePipe,
    TranslateModule,
    DatePipe,
    AsyncPipe,
  ],
  selector: 'tl-activity-block',
  standalone: true,
  styleUrls: ['./tl-activity-block.component.scss'],
  templateUrl: './tl-activity-block.component.html',
})
export class TrainingLogActivityBlockComponent implements OnInit {
  private modal: ModalService = inject(ModalService);
  private store: Store = inject(Store);

  @Input() activity: ActivityInformations;
  @Input() trainingLogInfos: { data: any; icon: string; label: string }[];

  completion_percent: number = 0;
  modalRenderedSubscription: Subscription;
  unit: 'imperial' | 'metric' = 'metric';
  workoutImgUrl: string | undefined;
  settings$: Observable<Settings> = this.store.select(selectSettings);
  suspiciousSvgActive: boolean = false;

  private fbiTyped: string = '';
  private fbiSequenceStart: number = 0;

  activitySessionListClick(): void {
    const modalClass: string = 'list-comments__modal';
    this.modal.display(modalClass);
    this.modalRenderedSubscription?.unsubscribe();

    setTimeout(() => {
      this.modal.setDialogComponent(TrainingLogSessionModalComponent);
    });

    if (
      this.modal.dialogComponent instanceof TrainingLogSessionModalComponent
    ) {
    } else {
      this.modalRenderedSubscription = this.modal.onModalRendered.subscribe(
        (component: TrainingLogSessionModalComponent) => {
          if (this.activity) {
            component.sessions = this.activity.sessions;
            component.unit = this.unit;
          }
        }
      );
    }
  }

  scroll(el: HTMLElement): void {
    el.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  @HostListener('window:keydown', ['$event'])
  onWindowKeydown(event: KeyboardEvent): void {
    const key: string = event.key?.toUpperCase();
    if (!key || key.length !== 1 || !/[A-Z]/.test(key)) {
      this.resetFbiSequence();
      return;
    }

    const now: number = Date.now();

    if (!this.fbiSequenceStart || now - this.fbiSequenceStart > 500) {
      this.fbiTyped = '';
      this.fbiSequenceStart = now;
    }

    if (!this.fbiTyped) {
      this.fbiSequenceStart = now;
    }

    this.fbiTyped += key;

    if (!'FBI'.startsWith(this.fbiTyped)) {
      this.resetFbiSequence();
      return;
    }

    if (
      this.fbiTyped.length === 'FBI'.length &&
      now - this.fbiSequenceStart <= 500
    ) {
      this.suspiciousSvgActive = true;
      setTimeout(() => (this.suspiciousSvgActive = false), 5000);
      this.resetFbiSequence();
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.completion_percent = this.activity.completion_percent;
    }, 500);

    if (this.activity.mode === 'workout') {
      this.workoutImgUrl = this.activity.thumbnails.large.replace('_dev', '');
    }
  }

  private resetFbiSequence(): void {
    this.fbiTyped = '';
    this.fbiSequenceStart = 0;
  }
}
